/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { FormattedMessage } from 'react-intl'

function NoSensibleInfoHere () {
  return (
    <FormattedMessage
      id="do_not_put_sensible_info_here"
      defaultMessage="Ne pas entrer d'informations sensibles ici (nom, prénom, téléphone, mail...)."
    />
  )
}

export default NoSensibleInfoHere
